/* unplugin-vue-components disabled */import script from "./search-add-user-view.vue?vue&type=script&setup=true&lang=js"
export * from "./search-add-user-view.vue?vue&type=script&setup=true&lang=js"

import "./search-add-user-view.vue?vue&type=style&index=0&id=4ca39348&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca39348"]])

export default __exports__